<template>
  <div v-if="isLoading" class="ProfessionPageSectionLoading">
    <div class="grid grid-cols-2 gap-4">
      <content-placeholders
        v-for="i in 16"
        :key="i"
        :lines="1"
        :rounded="true"
        class="mb-20"
      >
        <content-placeholders-heading :img="true" />
        <content-placeholders-text />
      </content-placeholders>
    </div>
    <div class="text-center">
      <img
        v-lazy-load data-src="~/assets/img/loader.svg"
        width="100"
        class="m-auto"
        style="height: 5.5rem"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isLoading: {
      type: Boolean,
      required: true,
    },
  },
};
</script>
